export enum PageType {
	CATEGORY = '6',
	FAMILY = '7',
	NON_TAXO_NO_SUGGEST = '5',
	NO_SUGGEST = '4',
	STATIC = '1',
	SUGGEST = '3',
	SUPER_FAMILY = '2'
}
